var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayerPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 25,
    viewBox: "0 0 19 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.82148 0.796875C5.47061 0.796875 6.8075 2.13377 6.8075 3.7829V21.6991C6.8075 23.3482 5.47061 24.6851 3.82148 24.6851C2.17234 24.6851 0.835449 23.3482 0.835449 21.6991V3.7829C0.835449 2.13377 2.17234 0.796875 3.82148 0.796875ZM15.7656 0.796875C17.4147 0.796875 18.7516 2.13377 18.7516 3.7829V21.6991C18.7516 23.3482 17.4147 24.6851 15.7656 24.6851C14.1165 24.6851 12.7796 23.3482 12.7796 21.6991V3.7829C12.7796 2.13377 14.1165 0.796875 15.7656 0.796875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerPause);
export default __webpack_public_path__ + "static/media/player-pause.975b36f23e36a9b21e796f64c9ed08c8.svg";
export { ForwardRef as ReactComponent };